import { render, staticRenderFns } from "./CreateStatisticalReportModal.vue?vue&type=template&id=67cb7276&scoped=true&"
import script from "./CreateStatisticalReportModal.vue?vue&type=script&lang=ts&"
export * from "./CreateStatisticalReportModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb7276",
  null
  
)

export default component.exports